import { render, staticRenderFns } from "./eventsList.vue?vue&type=template&id=dcc427da&scoped=true&"
import script from "./eventsList.vue?vue&type=script&lang=js&"
export * from "./eventsList.vue?vue&type=script&lang=js&"
import style0 from "./eventsList.vue?vue&type=style&index=0&id=dcc427da&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc427da",
  null
  
)

export default component.exports